import React, { useEffect, useState } from "react";
import "./privatepoll.scss";
import axios from "axios";
import { useParams } from "react-router-dom";
import { api_url } from "../../utils/Enviroment";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { notifyError } from "../Toast";
import { useTheme } from "../../contexts/ThemeProvider";
import { detailPath } from "../../constants/Routes";

const Privatepoll = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const [accessCode, setAccessCode] = useState("")
  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate()
  const [id, setId] = useState("")


  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');
    setId(id)
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const SendAccessCode = async () => {
    try {
      const response = await axios.get(`${api_url}/pools/access-pool/${id}/${accessCode}`, {
        headers: {
          "Authorization": `Bearer ${accessToken}`,
        }
      });
      const res = response.data.data.poolId;
      navigate(detailPath(res));
    } catch (error) {
      notifyError("Check your temperature", "The code you entered is invlaid.");
      console.error('Error creating pool:', error);
    }
  };


  return (
    <>
      <section className="privatepoll">
        {/* <img src="\assets\video-upfront.png" alt="img" className="img-fluid video-upfront" />
        <video className="main-banner-video"
          muted="muted" playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo">
          <source src="https://res.cloudinary.com/drt6vurtt/video/upload/v1733933202/rain-prediction/-dd05-4629-b935-11bd8f66df2c_juevny.mov" type="video/mp4" />
        </video> */}
        <div className="custom-container">
          <div className="privatepollinner">
            {
              theme === 'dark' ? <img src="/assets/poll/logo.svg" alt="logoimg" className="logoimg" /> : <img src="/assets/poll/logolight.svg" alt="logoimg" className="logoimg" />
            }
            <h4 className="privatepollhead">{t('Private Market')}</h4>
            <p className="privatepollpara">{t('Enter access code to continue')}</p>
            <input
              type="number"
              inputMode="numeric"
              placeholder={t("Enter access code")}
              className="privatepollinput"
              onChange={(e) => setAccessCode(e.target.value)}
              value={accessCode}
            />
            <button disabled={!accessCode} onClick={() => SendAccessCode()} className="privatepollbtn">
              {t('Continue')}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
              >
                <path
                  d="M15.5855 10.0149L10.523 15.0774C10.4174 15.1829 10.2743 15.2422 10.125 15.2422C9.97573 15.2422 9.83258 15.1829 9.72703 15.0774C9.62148 14.9718 9.56219 14.8287 9.56219 14.6794C9.56219 14.5301 9.62148 14.387 9.72703 14.2814L13.8298 10.1794H2.8125C2.66332 10.1794 2.52024 10.1201 2.41475 10.0146C2.30926 9.90915 2.25 9.76607 2.25 9.61689C2.25 9.46771 2.30926 9.32463 2.41475 9.21914C2.52024 9.11365 2.66332 9.05439 2.8125 9.05439H13.8298L9.72703 4.95236C9.62148 4.84681 9.56219 4.70366 9.56219 4.55439C9.56219 4.40512 9.62148 4.26197 9.72703 4.15642C9.83258 4.05087 9.97573 3.99158 10.125 3.99158C10.2743 3.99158 10.4174 4.05087 10.523 4.15642L15.5855 9.21892C15.6378 9.27116 15.6793 9.3332 15.7076 9.40149C15.7359 9.46977 15.7504 9.54297 15.7504 9.61689C15.7504 9.69081 15.7359 9.76401 15.7076 9.83229C15.6793 9.90058 15.6378 9.96262 15.5855 10.0149Z"
                  fill="black"
                />
              </svg>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Privatepoll;
